import React, { Component } from "react";
import Image from "../Image";

export default class CustomLoader extends Component {
  render() {
    const { display } = this.props;
    return (
      <div class="preloader" style={{ display: !!display ? "flex" : "none" }}>
        <div class="content">
          <div class="loader-circle"></div>
          <div class="loader-line-mask">
            <div class="loader-line"></div>
          </div>
          <Image src={"/bajaj_favicon.png"} alt="" />
        </div>
      </div>
    );
  }
}
